import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-solutions',
    templateUrl: './solutions.component.html',
    styleUrls: ['./solutions.component.css'],
    standalone: false
})
export class SolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
